import { ProductAttributes } from '@dora/backpack';
import * as RTK from '@reduxjs/toolkit';
import { ProductVariantWithAttributes } from '../data/productVariant';

/**
 * This state supports the variant swapping feature in Visual Inspiration. Shape Up Cycle 0, Nov 2022.
 *
 * Created specifically for this feature, it represents product data in terms of ProductVariantOptions and
 * ProductVariantAttributes as returned from the Gift endpoint GET/variantsByGroupingCode (TODO: this endpoint has not
 * actually been defined yet and may not be called that).
 *
 * ProductVariantOptions represent a product variant that differs from the starting variant on one or more Axes of Variation,
 * which are expanded on in the ProductVariantAttributes field; currently these are limited to Dimension and Finish.
 */

export type State = {
    // product variant options related to launch product variant
    productVariantOptions: Array<ProductVariantWithAttributes> | null;
    // attributes present in the variant options
    productVariantAttributes: ProductAttributes.AttributeProperties | null;
};

const initialState: State = {
    productVariantAttributes: null,
    productVariantOptions: null,
};

export const slice = RTK.createSlice({
    name: 'variant-data',
    initialState,
    reducers: {
        setProductVariantData(_state, action: RTK.PayloadAction<State>) {
            return action.payload;
        },
        clearVariantData(_state, _: RTK.Action) {
            return initialState;
        },
    },
});

export const { setProductVariantData, clearVariantData } = slice.actions;

export const reducer = slice.reducer;
